import React from "react";
import Icons from "../../../../config/images";
import "./WhyBACode.css";

const WhyBACode = () => {
  return (
    <section className="why-ba-code-section">
      <div className="why-ba-code-content">
        <h2>Why BA Code Solution?</h2>

        <ul className="why-ba-code-list">
          <li>Industry-specific expertise in jewellery workflows</li>
          <li>Custom-built solutions (no forced templates)</li>
          <li>Scalable architecture for growing businesses</li>
          <li>Transparent communication & reliable support</li>
          <li>Focus on performance, security, and usability</li>
          <li>Jewellery-focused ERP & e-commerce expertise</li>
          <li>Long-term technology partnership, not just development</li>
        </ul>
      </div>

      <div className="why-ba-code-img">
        <img src={Icons.why_bacode_img} alt="Why BA Code Solution" />
      </div>
    </section>
  );
};

export default WhyBACode;
